import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { apiErr } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { ThemeToggle } from "@/components/ThemeToggle";
import { Logo } from "@/components/Logo";
import { PackageCheck, ArrowRight } from "lucide-react";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      nav("/dashboard");
    } catch (err) {
      toast.error(apiErr(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-background">
      <div className="hidden lg:block relative border-r border-border">
        <img
          src="https://images.unsplash.com/photo-1776521905669-97fa944bf30c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHw0fHxkZWxpdmVyeSUyMHRydWNrJTIwaGlnaHdheXxlbnwwfHx8fDE3ODYwNzYyNDh8MA&ixlib=rb-4.1.0&q=85"
          alt="Fleet"
          className="absolute inset-0 h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-black/60" />
        <div className="absolute bottom-0 p-12">
          <Logo className="h-16" />
          <p className="mt-6 max-w-sm text-white/80 text-lg">Logistics management & quotation engine. Precision from lead to dispatch.</p>
        </div>
      </div>

      <div className="flex flex-col">
        <div className="flex justify-between items-center p-6">
          <div className="lg:hidden"><Logo className="h-8" /></div>
          <div className="ml-auto"><ThemeToggle /></div>
        </div>
        <div className="flex-1 grid place-items-center px-6 pb-16">
          <form onSubmit={submit} className="w-full max-w-sm space-y-6" data-testid="login-form">
            <div>
              <div className="text-xs font-bold uppercase tracking-widest text-primary mb-2">Staff Console</div>
              <h1 className="font-heading font-black text-4xl tracking-tight">Sign in</h1>
              <p className="text-muted-foreground text-sm mt-1">Admin · Manager · Calling Executive</p>
            </div>
            <div className="space-y-2">
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" data-testid="login-email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@arrowlogistics.com" required />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password">Password</Label>
              <Input id="password" type="password" data-testid="login-password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" required />
            </div>
            <Button type="submit" disabled={loading} data-testid="login-submit" className="w-full gap-2 rounded-none h-11 font-bold uppercase tracking-wide">
              {loading ? "Signing in…" : <>Enter console <ArrowRight className="h-4 w-4" /></>}
            </Button>
            <a href="/" className="block text-center text-sm text-muted-foreground hover:text-primary transition-colors">← Back to public quote form</a>
          </form>
        </div>
      </div>
    </div>
  );
}
